/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./MenuWithTick',
	'underscore'
], function(MenuWithTick,  _) {

	/**
	 * Represents a drop down menu that can be added to an app bar
	 */
	var ToggleMenuBar = MenuWithTick.extend({
		itemMap: {},
		sCheckedItemName: null,
		updateLabel: false,

		/**
		 * Creates a new item
		 *
		 * @param spec -
		 *            The item spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 */
		init: function(spec) {
			_.extend(this, spec);
			ToggleMenuBar.inherited('init', this, arguments);
		},

		toggleHandler: function(name) {
			this.updateSelectedItem(name);
		},

		/**
		 * Make sure only one item is selected
		 */
		updateSelectedItem: function(name) {
			var item = this.itemMap[name];
			if(!item || !item.children) {
				// if we haven't selected an item, we do not update the tick
				return;
			}
			//uncheck current item
			if (this.sCheckedItemName) {
				//update tick mark on menu item
				this.updateMenuItemTick(this.itemMap[this.sCheckedItemName], false);
			}
			//update check item name
			this.sCheckedItemName = name;
			//update tick mark on menu item
			this.updateMenuItemTick(this.itemMap[this.sCheckedItemName], true);
			if (this.updateLabel) {
				if (this.$menuLabel.length > 0 && item.children) {
					this.$menuLabel.text(item.children('a').attr('aria-label'));
				}
			}
		},
		render: function() {
			let promise = ToggleMenuBar.inherited('render', this, arguments);
			if (this.updateLabel) {
				_.each(this.items, (item) => {
					if (item.checked) {
						this.updateSelectedItem(item.name);
					}
				});
				if (!this.sCheckedItemName) {
					this.updateSelectedItem(this.items[0].name);
				}
			}
			return promise;
		},

		_performAction: function(id) {
			this.updateSelectedItem( this._getItemNameFromID(id) );
			ToggleMenuBar.inherited('_performAction', this, arguments);
		},

		_getItemNameFromID: function(id) {
			var prefix = this.viewId + '_';
			return id.substr(prefix.length);
		},


		_buildDropDown: function() {
			let promise = ToggleMenuBar.inherited('_buildDropDown', this, arguments);

			//populate itemMap to reference elements by name
			_.each(this.items, (item) => {
				let id = this._getItemId(item.name);
				this.itemMap[item.name] = this.$menu.find('#' + id);

				if (item.checked) {
					this.sCheckedItemName = item.name;
				}
			});

			this.updateMenuItemTick(this.itemMap[this.sCheckedItemName], true);

			return promise;
		},

		remove: function() {
			_.each(this.itemMap, (item) => {
				if (item.remove) {
					item.remove();
				}
			});

			ToggleMenuBar.inherited('remove', this, arguments);
		}

	});

	return ToggleMenuBar;
});
